import { FOR_YOU_MORE } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * For You More Reducer
 * @param {*} state
 * @param {*} action
 */
export default function forYouMore(state = initialState, action = {}) {
  switch (action.type) {
    case `${FOR_YOU_MORE}_PENDING`:
      return {
        ...state,
        error: null, // state.error = null
        loaded: false, // state.loaded = false
        loading: true, // state.loading = true
      };
    case `${FOR_YOU_MORE}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${FOR_YOU_MORE}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
